/** @jsxImportSource @emotion/react */
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
} from "@coreai/component-library";
import { css } from "@emotion/react";

interface CampaignDialogProps {
  campDescription: string;
  title: string;
  open: boolean;
  onClose: () => void;
}

export default function CampaignDialog(
  props: Readonly<CampaignDialogProps>
) {
  const dialogheaderStyles = () => css`
    h2 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0px 20px;
    }
  `
 
  return (
    <Dialog
      open={props.open}
      onOpenChange={(isOpen) => !isOpen && props.onClose()}
    >      
        <DialogContent size="sm">
          <DialogHeader css={dialogheaderStyles}>
            <DialogTitle >{props?.title}</DialogTitle>
          </DialogHeader>
          <DialogBody>
                <div>
                  {props?.campDescription}
                </div>                              
          </DialogBody> 
        </DialogContent>
    </Dialog>
  );
}
